import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { alpha } from "@material-ui/core/styles";
import { DateRangePicker, DateRangeDelimiter } from "@material-ui/pickers";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import * as Var from "../../styles/variables";
import FilterDownload from "../../components/Filter/FilterDownload";

import {
  setCurrentPageNumber,
  setFilterDrawerState,
  setFilterDownload,
} from "../../actions";
import moment from "moment";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: alpha("#fafafa", 1),
      marginTop: theme.spacing(-2),
      zIndex: 1000,
      paddingTop: 0,
      paddingLeft: 8,
      marginTop: -12,
    },
    container: {
      display: "flex",
      width: 300,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignItems: "baseline",
    },
    calendarSection: {
      marginTop: "10px",
    },
    delimiter: {
      paddingTop: theme.spacing(1),
    },
    dataBtn: {
      marginTop: theme.spacing(1.2),
      marginLeft: theme.spacing(1),
      height: theme.spacing(4),
      paddingTop: theme.spacing(1.5),
      color: Var.btnLabelColor,
    },
    sectionCalendar: {
      display: "flex",
    },
    filterBtn: {
      marginTop: theme.spacing(1.2),
      height: theme.spacing(4),
      paddingTop: theme.spacing(1.5),
    },
  })
);

const DownloadCalendar = ({
  companyName,
  minMaxDateRange,
  setCurrentPageNumber,
  setFilterDrawerState,
  filterDownload,
  setFilterDownload,
}) => {
  const anchor = "right";
  const classes = useStyles();
  const [error, setError] = useState([null, null]);
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const [downloadDateRange, setDownloadDateRange] = useState(() => {
    if (
      filterDownload &&
      filterDownload.dateRange &&
      filterDownload.dateRange.start &&
      filterDownload.dateRange.end
    ) {
      return [
        moment(filterDownload.dateRange.start, "YYYY-MM-DD"),
        moment(filterDownload.dateRange.end, "YYYY-MM-DD"),
      ];
    }
    const defaultStart =
      minMaxDateRange && minMaxDateRange[0]
        ? minMaxDateRange[0]
        : moment("2025-08-15");
    const defaultEnd =
      minMaxDateRange && minMaxDateRange[1]
        ? minMaxDateRange[1]
        : moment();
    return [defaultStart, defaultEnd];
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
    setFilterDrawerState(open);
  };

  const handleDateChange = (newValue) => {
    setDownloadDateRange(newValue);

    const [start, end] = newValue;
    if (!start || !end) return;

    const nextFilter = {
      ...filterDownload, // areaGroup など既存の条件はそのまま保持
      dateRange: {
        start: start.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
      },
    };

    setFilterDownload(nextFilter);
    setCurrentPageNumber(1);
  };

  const renderContent = () => {
    if (companyName === "tepco") return (
      <FilterDownload
        toggleDrawer={toggleDrawer}
        anchor={anchor}
      />
    );
    return null;
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={3} direction="row">
        <Grid item>
          <DateRangePicker
            startText="開始"
            endText="終了"
            disableHighlightToday={true}
            showToolbar={false}
            allowSameDateSelection={true}
            minDate={minMaxDateRange[0] !== null ? minMaxDateRange[0] : null}
            maxDate={minMaxDateRange[1] !== null ? minMaxDateRange[1] : null}
            value={downloadDateRange}
            onChange={handleDateChange}
            onError={([startReason, endReason], [start, end]) => {
              if (startReason === "invalidRange") {
                setError([null, null]);
                return;
              }
              setError([startReason, endReason]);
            }}
            renderInput={(startProps, endProps) => (
              <div className={classes.container}>
                <TextField
                  id="standard-basic"
                  {...startProps}
                  error={Boolean(error[0])}
                  size="small"
                  helperText=""
                />
                <DateRangeDelimiter>
                  <span className={classes.delimiter}>~</span>
                </DateRangeDelimiter>
                <TextField
                  id="standard-basic"
                  {...endProps}
                  error={Boolean(error[0])}
                  size="small"
                  helperText=""
                />
              </div>
            )}
          />
        </Grid>
        <Grid item>
          <Button
            className={classes.filterBtn}
            variant="contained"
            color="default"
            onClick={toggleDrawer(anchor, true)}
          >
            絞り込み
          </Button>
          <Drawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
          >
            {renderContent()}
          </Drawer>
        </Grid>
      </Grid>
    </div>
  );
};

DownloadCalendar.propTypes = {
  classes: PropTypes.object.isRequired,
  companyName: PropTypes.string,
  minMaxDateRange: PropTypes.array,
  filterDrawerState: PropTypes.bool,
  filterDownload: PropTypes.object,
  setCurrentPageNumber: PropTypes.func.isRequired,
  setFilterDrawerState: PropTypes.func.isRequired,
  setFilterDownload: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  minMaxDateRange: state.app.minMaxDateRange,
  filterDrawerState: state.app.filterDrawerState,
  filterDownload: state.download.filterDownload,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPageNumber: (param) => dispatch(setCurrentPageNumber(param)),
  setFilterDrawerState: (param) => dispatch(setFilterDrawerState(param)),
  setFilterDownload: (param) => dispatch(setFilterDownload(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(DownloadCalendar));
